import { useState, useCallback, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import styles from './Navbar.module.css';

const navItems = [
  { path: '/', label: 'Inicio' },
  { path: '/about', label: 'Acerca de Login' },
  { path: '/login', label: 'Iniciar sesión' },
  { path: '/registro', label: 'Registro' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('usuario');
    setUsuario(null);
    setMenuOpen(false);
    navigate('/');
    window.dispatchEvent(new CustomEvent('user-logout'));
  };

  useEffect(() => {
    try {
      const stored = localStorage.getItem('usuario');
      setUsuario(stored ? JSON.parse(stored) : null);
    } catch {
      setUsuario(null);
    }
  }, [location.pathname]);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const linkClass = ({ isActive }) =>
    `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`;

  const mobileLinkClass = ({ isActive }) =>
    `${styles.mobileLink} ${isActive ? styles.mobileLinkActive : ''}`;

  return (
    <nav className={styles.navbar}>
      <div className={styles.navInner}>
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
        >
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
          <span className={styles.hamburgerLine} />
        </button>
      </div>

      {menuOpen && (
        <div
          className={styles.menuOverlay}
          aria-hidden="true"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <div
        className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}
        aria-hidden={!menuOpen}
        onClick={(e) => e.stopPropagation()}
      >
        {navItems
          .filter((item) => !usuario || (item.path !== '/login' && item.path !== '/registro' && item.path !== '/about'))
          .concat(usuario ? [
            { path: '/agenda', label: 'Agenda' },
            { path: '/informacion-logistica', label: 'Información logística' },
            ...(usuario?.es_staff ? [{ path: '/admin/preguntas', label: 'Ver preguntas' }] : []),
          ] : [])
          .map(({ path, label }) => (
            <NavLink
              key={path}
              to={path}
              className={mobileLinkClass}
              end={path === '/'}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
        {usuario && (
          <button type="button" className={styles.mobileLink} onClick={handleLogout}>
            Cerrar sesión
          </button>
        )}
      </div>
    </nav>
  );
}
